import type { JSX } from "react"
import { useAppSelector } from "../../app/hooks"
import { Eye, EyeClosed } from "lucide-react"

export const Footer = (): JSX.Element | null => {
  const homeSlice = useAppSelector(state => state.home)

  return (
    <div className="flex items-center justify-between px-8 py-4">
      {/* <h1 className="p-2">{homeSlice.gameState}</h1> */}
      {homeSlice.gameState === "running" ? <Eye /> : <EyeClosed />}
      <p>Joey Prüssing</p>
    </div>
  )
}
